import groq from 'groq'

import { ArticlesTypeQuery } from '~/app/queries/sections/ArticlesTypeQuery'
import { CallToActionQuery } from '~/app/queries/sections/CallToActionQuery'
import { ContactFormSectionQuery } from '~/app/queries/sections/ContactFormSectionQuery'
import { EmployeesTypeQuery } from '~/app/queries/sections/EmployeesTypeQuery'
import { EventTypeQuery } from '~/app/queries/sections/EventTypeQuery'
import { GalleryQuery } from '~/app/queries/sections/GalleryQuery'
import { LogoGalleryQuery } from '~/app/queries/sections/LogoGalleryQuery'
import { LogoGallery2Query } from '~/app/queries/sections/LogoGallery2Query'
import { textContainerQuery } from '~/app/queries/sections/textContainerQuery'
import { heroQuery } from '~/app/queries/sections/HeroQuery'
import { textWithIllustrationQuery } from '~/app/queries/sections/TextWithIllustrationQuery'
import { FaneModulQuery } from '~/app/queries/sections/FaneModulQuery'
import { DownloadQuery } from '~/app/queries/molecules/DownloadQuery'
import { PriceBoxesQuery } from '../sections/PriceQuery'
import { LinkBoxGalleryQuery } from '../sections/LinkBoxGalleryQuery'
import { ThreeColumnSectionQuery } from '../sections/ThreeColumnSectionQuery'
import { accordionType } from '~/app/schemas/sections/atoms/accordionType'
import { AccordionQuery } from '../molecules/AccordionQuery'
import { PageTitleQuery } from '../sections/PageTitleQuery'
import { AdvantagesQuery } from '../sections/AdvantagesQuery'
import { MediaTypeQuery } from '../atoms/MediaTypeQuery'
import { JobQuery } from '../sections/JobTypeQuery'
export const pageBuilderQuery = groq`
  pageBuilder[] {
    ${textWithIllustrationQuery},
    ${ArticlesTypeQuery},
    ${EventTypeQuery},
    ${JobQuery},
    ${MediaTypeQuery},
    ${ContactFormSectionQuery},
    ${heroQuery},
    ${AccordionQuery},
    ${FaneModulQuery},
    ${DownloadQuery},
    ${PriceBoxesQuery},
    ${LinkBoxGalleryQuery},
    ${textContainerQuery},
    ${CallToActionQuery},
    ${EmployeesTypeQuery},
    ${GalleryQuery},
    ${LogoGalleryQuery},
    ${LogoGallery2Query},
    ${AdvantagesQuery},
    ${ThreeColumnSectionQuery},
    ${PageTitleQuery},
  }
`
